import { formatISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const dateToString = (date: Date) =>
    formatISO(
        toZonedTime(date, Intl.DateTimeFormat().resolvedOptions().timeZone)
    );
